import { Button, Table } from "react-bootstrap";

import React from "react";

import SelectWrap from "../../components/SelectWrap";
import SyncMessage from "../../components/SyncMessage";
import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import API from "../../services/API";

import config from "../AdkPartnerDomains/config";

import './index.css'

class AdkDomains extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            syncData: null,
            original: {},
            domains: {},
        }

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.loadDomains = this.loadDomains.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        (async () => {
            this.loadDomains().catch(console.error);
        })();
    }

    async handleSync() {
        if (!window.confirm(`Are you sure to perform sync?`)) return;

        this.setState({ loading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'domains')
            .then((res) => {
                this.setState({ loading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch((err) => {
                this.setState({ loading: false, syncData: { reqErr: err } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    async loadDomains() {
        this.setState({ loading: true });

        const domains = (await API.ADKDomains.get())
            .reduce((object, domain) => (object[domain.type] = [ ...(object[domain.type] || []), domain ], object), {});

        this.setState({ loading: false, domains, original: JSON.parse(JSON.stringify(domains)) });
    }

    async handleFieldChange(type, index, name, value) {
        const state = this.state;

        state.domains[type][index][name] = value;

        this.setState(state);
    }

    async handleSave(type, index) {
        const original_domain = this.state.original[type][index];
        const modified_domain = this.state.domains[type][index];

        if (!window.confirm(`${original_domain.type}${original_domain.day ? `:${original_domain.day}` : ''} | "${original_domain.domain}" => "${modified_domain.domain}"`)) return;

        this.setState({ loading: true });

        await API.ADKDomains.update(modified_domain).catch(console.error);

        await this.loadDomains();
    }

    render() {
        return (
            <Container id={'adk-domains'} loading={this.state.loading}>
                <Heading title="ADK Domains" />

                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button bsStyle="success" onClick={this.handleSync}>Sync</Button>
                </div>

                <div style={{ width: '100%', marginTop: '5px' }}>
                    <SyncMessage {...this.state.syncData} />
                </div>

                {
                    Object.entries(this.state.domains)
                        .map(([ type, domains ]) => {
                            return (
                                <div key={type}>
                                    <h3>{type}</h3>
                                    <div>
                                        <div>
                                            <Table bordered responsive style={{ width: '100vw', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <thead>
                                                    <tr>
                                                        {domains.length > 1 && <th>Day</th>}
                                                        <th>Domain</th>
                                                        <th>Virustotal Configuration</th>
                                                        <th>Virustotal Threshold</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {domains.map(({ id, day, domain, virustotal_configuration, virustotal_threshold, active }, index) => (
                                                        <tr style={{ border: active ? `2px solid green`: '' }} key={id}>
                                                            {domains.length > 1 && <th style={{ width: '1%', verticalAlign: 'middle', textAlign: 'center'}}>{day}</th>}

                                                            <td style={{ width: '20%' }}>
                                                                <FieldGroup type={'text'} value={domain || ""} onChange={(event) => this.handleFieldChange(type, index, 'domain', event.target.value)} />
                                                            </td>

                                                            <td style={{ width: '10%' }}>
                                                                <SelectWrap
                                                                    value={virustotal_configuration}
                                                                    values={config.virustotal_configuration}
                                                                    onChange={(event) => this.handleFieldChange(type, index, 'virustotal_configuration', event.target.value)}
                                                                />
                                                            </td>

                                                            <td style={{ width: '10%' }}>
                                                                <FieldGroup
                                                                    onChange={(event) => this.handleFieldChange(type, index, 'virustotal_threshold', event.target.value)}
                                                                    value={virustotal_threshold}
                                                                    type={'number'}
                                                                    step={'1'}
                                                                />
                                                            </td>

                                                            <td style={{ width: '1%', verticalAlign: 'middle' }}>
                                                                <Button bsStyle={'primary'} onClick={() => this.handleSave(type, index)}>Save</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                    <hr />
                                </div>
                            )
                        })
                }
            </Container>
        )
    }
}

export default AdkDomains;



// WEBPACK FOOTER //
// ./src/scenes/AdkDomains/index.js